import React from 'react'
import PropTypes from 'prop-types'

import BlockUserModal from './BlockUserModal'

class BlockUserButton extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalOpen: false,
      isBlocker: props.isBlocker,
      blockedRecordId: props.blockedRecordId,
    }

    this.toggleModal = this.toggleModal.bind(this)
    this.handleBlocked = this.handleBlocked.bind(this)
    this.handleUnblocked = this.handleUnblocked.bind(this)
  }

  toggleModal() {
    this.setState({ modalOpen: !this.state.modalOpen })
  }

  handleBlocked() {
    window.location.reload()
  }

  handleUnblocked() {
    window.location.reload()
  }

  render() {
    const { userId, userName, currentUserId } = this.props
    const { modalOpen, isBlocker, blockedRecordId } = this.state
    const flagClass = isBlocker ? 'blocked-user-flag' : 'block-user-flag'
    const buttonClass = [
      'profile-hero__flagBtn',
      isBlocker ? 'profile-hero__flagBtn--blocked' : '',
    ].filter(Boolean).join(' ')

    return (
      <>
        <button
          type="button"
          className={buttonClass}
          onClick={this.toggleModal}
          aria-label={isBlocker ? 'User blocked' : 'Block user'}
        >
          <svg className={flagClass} aria-hidden="true">
            <use xlinkHref="#flag" />
          </svg>
        </button>

        {modalOpen && (
          <BlockUserModal
            userId={userId}
            userName={userName}
            currentUserId={currentUserId}
            isBlocker={isBlocker}
            blockedRecordId={blockedRecordId}
            onClose={this.toggleModal}
            onBlocked={this.handleBlocked}
            onUnblocked={this.handleUnblocked}
          />
        )}
      </>
    )
  }
}

BlockUserButton.propTypes = {
  userId: PropTypes.number.isRequired,
  userName: PropTypes.string.isRequired,
  currentUserId: PropTypes.number.isRequired,
  isBlocker: PropTypes.bool.isRequired,
  blockedRecordId: PropTypes.number,
}

export default BlockUserButton
